import { Component } from '@angular/core';

import { MessageService } from '@services/message.service';
import { ConfiguracaoCaixaApiService } from '../../../services/configuracao-caixa-api.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-adicionar-tipo-dialog',
  standalone: false,
  templateUrl: './adicionar-tipo-dialog.component.html',
  styleUrl: './adicionar-tipo-dialog.component.scss'
})
export class AdicionarTipoDialogComponent {

  contaId: number;

  title: string = 'Adicionar tipo';
  nome: string = '';

  constructor(
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<AdicionarTipoDialogComponent>
  ) { }

  public salvarClick(): void {
    if (!this.nome?.trim()) {
      this.messageService.showToastWarning("O nome não pode ser vazio")
      return;
    }

    this.configuracaoCaixaApiService.saveCriarTipoLancamento(this.contaId, this.nome).subscribe(() => {
      this.messageService.showToastSuccess("Salvo com sucesso")
      this.dialogRef.close(true);
    });
  }
}
